

// Import ----------------------------------------------------------------------

// Project
import { VueGlobalInjectable } from "~/libs/Types";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component Attribute, Properties & Injected ------------------------------

    inject: ["node"],

    computed: {
        links (): [] {
            return this.node.toc;
        }
    }

    // -------------------------------------------------------------------------
});
